export default __webpack_public_path__ + "images/0x80487b4f8f70e793a81a42367c225ee0b94315df.png";